import { Extensions } from './Extensions'

export class ShippingExtensions extends Extensions {}
